import React from "react";
import { Select } from "antd";

import { InputWrapper, Label } from "./styledComponents";

type VehicleType = "COMBUSTION" | "HYBRID" | "ELECTRIC";

type Props = {
  id: string;
  value?: VehicleType | string;
  onChange: (value: string) => void;
  wrapperStyle?: React.CSSProperties;
  disabled?: boolean;
};

const VEHICLE_TYPE_OPTIONS: Array<{ value: VehicleType; label: string }> = [
  { value: "COMBUSTION", label: "Verbrennerfahrzeug" },
  { value: "HYBRID", label: "Hybrid" },
  { value: "ELECTRIC", label: "Elektrofahrzeug" },
];

const VehicleTypeSelect = ({
  id,
  value,
  onChange,
  wrapperStyle,
  disabled,
}: Props) => (
  <InputWrapper style={wrapperStyle}>
    <Label htmlFor={id}>Fahrzeugtyp</Label>
    <Select
      id={id}
      value={value}
      style={{ width: "280px" }}
      disabled={disabled}
      onChange={(nextValue) => onChange(String(nextValue))}
      options={VEHICLE_TYPE_OPTIONS}
    />
  </InputWrapper>
);

export default VehicleTypeSelect;
